import React from 'react';
import SellingPage from '../../components/pages/sell/index';
import PageBase from '../../components/layout/PageBase';

export class Sell extends React.Component {
  render() {
    return (
      <PageBase
        title="Torii: Sell your home with confidence"
        overrideRemarks="List your property with our expert local real estate agents."
        disableOverflow
      >
        <div className="page-container home-container row center-xs">
          <SellingPage />
        </div>
      </PageBase>
    );
  }
}

export default Sell;
